import 'core-js/stable'
import './../scss/app.scss'
import Vue from 'vue'
import Vuex, {
    mapActions,
    mapGetters,
} from 'vuex'
import axios from 'axios'
import lozad from 'lozad'
import 'regenerator-runtime/runtime'
import store from './store/index.js'
import Velocity from 'velocity-animate'
import Multiselect from 'vue-multiselect'
import FormError from './utilities/form-errors'
import '@fortawesome/fontawesome-free/js/brands.min'
import '@fortawesome/fontawesome-free/js/solid.min'
import '@fortawesome/fontawesome-free/js/fontawesome.min'

Vue.prototype.$lozad = lozad()
Vue.prototype.$lozad.observe()
Vue.use(Vuex)

import('vue2-touch-events').then((module) => {
    Vue.use(module)
})


import('vue-instantsearch').then((module) => {
    Vue.use(module)
})

Vue.component('modal', import('./components/utilities/Modal.vue'))

Vue.component('pagination', import('./components/utilities/Pagination.vue'))

Vue.component('multiselect', Multiselect)

let menus = document.querySelectorAll('.main-menu')
menus.forEach((menu) => {
    new Vue({
        el: '.main-menu-' + menu.dataset.id,
        store,
        data: {
            counter: 0,
            isSideBarActive: false,
            isVideoModalActive: false,
        },
        mounted() {

        },
        computed: {
            ...mapGetters({
                phone: 'phone',
                isMobile: 'isMobile',
            }),
        },
        methods: {
            onMouseHover() {
                this.openSubMenu()
            },
            onMouseLeft() {
                if (this.isMobile) return
                this.closeSubMenu()
            },
        },
        components: {
            'main-menu': () => import('./components/nav/Menu.vue'),
        },
    })
})

let videoContainers = document.querySelectorAll('.video-container')
videoContainers.forEach((container) => {
    new Vue({
        el: '.video-container-' + container.dataset.id,
        store,
        components: {
            'video-wrapper': () => import('./components/VideoWrapper.vue')
        },
    })
})

let ytVideoContainers = document.querySelectorAll('.yt-player')
if (ytVideoContainers.length) {
    let tag = document.createElement('script')
    let firstScriptTag = document.getElementsByTagName('script')[0]
    tag.src = 'https://www.youtube.com/player_api'
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    ytVideoContainers.forEach((container) => {
        new Vue({
            el: '.yt-player-' + container.dataset.id,
            store,
            components: {
                'yt-player': () => import('./components/YouTube.vue'),
            },
        })
    })
}

let imageSliders = document.querySelectorAll('.image-slider')
imageSliders.forEach((slider) => {
    new Vue({
        el: '.image-slider-' + slider.dataset.id,
        store,
        components: {
            'image-slider': () => import('./components/ImageSlider.vue'),
        },
    })
})

let allTestimonials = document.querySelectorAll('.all-testimonials')
allTestimonials.forEach((testimonial) => {
    new Vue({
        el: '.all-testimonials-' + testimonial.dataset.id,
        store,
        components: {
            'all-testimonials': () => import('./components/testimonials/AllTestimonials.vue'),
        },
    })
})

let testimonials = document.querySelectorAll('.testimonials')
testimonials.forEach((item) => {
    new Vue({
        el: '.testimonials-' + item.dataset.id,
        components: {
            'testimonials': () => import('./components/testimonials/Testimonials.vue'),
        },
    })
})

let faqs = document.querySelectorAll('.faqs')
faqs.forEach((faq) => {
    new Vue({
        el: '.faq-' + faq.dataset.id,
        components: {
            'faq': () => import('./components/Faq.vue'),
        },
    })
})

let recentPosts = document.querySelectorAll('.recent-posts')
recentPosts.forEach((recentPost) => {
    new Vue({
        el: '.recent-posts-' + recentPost.dataset.id,
        components: {
            'blog-posts': () => import('./components/blog/BlogPosts.vue'),
        },
    })
})

let postCategories = document.querySelectorAll('.post-categories')
postCategories.forEach((postCategory) => {
    new Vue({
        el: '.post-categories-' + postCategory.dataset.id,
        components: {
            'post-categories': () => import('./components/blog/PostCategories.vue')
        },
    })
})

let googleMaps = document.querySelectorAll('.google-maps')
googleMaps.forEach((map) => {
    new Vue({
        el: '.google-maps-' + map.dataset.id,
        components: {
            'pi-google-map': () => import('./components/utilities/GoogleMap.vue')
        },
    })
})

let featuredPosts = document.querySelectorAll('.featured-posts')
featuredPosts.forEach((featuredPost) => {
    new Vue({
        el: '.featured-posts-' + featuredPost.dataset.id,
        components: {
            'featured-posts': () => import('./components/blog/FeaturedPosts.vue'),
        },
    })
})

let blockedPosts = document.querySelectorAll('.blocked-posts')
blockedPosts.forEach((post) => {
    new Vue({
        el: '.blocked-posts-' + post.dataset.id,
        components: {
            'blocked-posts': () => import('./components/BlockedPosts.vue'),
        },
    })
})

let resources = document.querySelectorAll('.resources')
resources.forEach((resource) => {
    new Vue({
        el: '.resources-' + resource.dataset.id,
        components: {
            'resources': () => import('./components/resources/Resources.vue'),
        },
    })
})

let allResources = document.querySelectorAll('.all-resources')
allResources.forEach((resource) => {
    new Vue({
        el: '.all-resources-' + resource.dataset.id,
        components: {
            'all-resources': () => import('./components/resources/AllResources.vue'),
        },
    })
})

let algoliaSearches = document.querySelectorAll('.algolia-search')
algoliaSearches.forEach((search) => {
    new Vue({
        el: '.algolia-search-' + search.dataset.id,
        store,
        components: {
            'algolia-search': () => import('./components/algolia/PiAlgolia.vue'),
        },
    })
})

let algoliaResults = document.querySelectorAll('.algolia-results')
algoliaResults.forEach((result) => {
    new Vue({
        el: '.algolia-results-' + result.dataset.id,
        store,
        components: {
            'algolia-results': () => import('./components/algolia/AlgoliaResults.vue'),
        },
    })
})

let newsletterForms = document.querySelectorAll('.newsletter-form')
newsletterForms.forEach((newsletterForm) => {
    new Vue({
        el: '.newsletter-form-' + newsletterForm.dataset.id,
        data: {
            formError: new FormError(),
            name: '',
            phone: '',
            email: '',
            message: '',
            key: '6Lc2xrkUAAAAAMJ3mjygXXOkJ706HC2_Q11IfZdi',
        },
        props: {
            redirectUrl: {
                type: String,
                required: true,
                default: '/',
            },
            hasLabels: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            subscribe() {
                let formData = new FormData
                let captchaResponse = document.getElementById(
                    'newsletter-captcha').dataset.response
                if (captchaResponse.length <= 0) {
                    Swal.fire({
                        title: 'Thank you!',
                        text: 'Unable to verify, please check the recaptcha checkbox',
                        type: 'info',
                    })
                }
                formData.append('action', 'form_submission')
                formData.append('client_name', this.name)
                formData.append('phone', this.phone)
                formData.append('email', this.email)
                formData.append('type', 'newsletter-form')
                formData.append('website_url', window.location.href)
                formData.append('g_recaptcha_response', captchaResponse)
                formData.append('message', this.message)

                axios.post(ajaxObject.url, formData).then(() => {
                    window.location.href = this.redirectUrl
                }).catch((error) => {
                    Swal.fire({
                        title: 'Thank you!',
                        text: 'We have received your information and a member of our admissions staff will be in touch with you shortly.',
                        type: 'info',
                    }).then(() => {
                        console.log(error)
                        if (typeof error.response.errors !== 'undefined') {
                            this.formError.record(error.response.errors)
                        }
                    })
                })
            },
        },
    })
})

let ttcForms = document.querySelectorAll('.ttc-form')
ttcForms.forEach((verify) => {
    new Vue({
        el: '.ttc-form-' + verify.dataset.id,
        data() {
            return {
                formError: new FormError(),
                first_name: '',
                last_name: '',
                member_id: '',
                payer_id: '',
                date_of_birth: '',
                client_type: 'prospect',
                subscriber_relation: 'myself',
                insurance_phone: '',
                client_email: '',
                client_phone: '',
                ssn: '',
                gender: '',
                carriers: [],
                key: '6LcZxrkUAAAAAGrd8j9LAK-XELENhJhk3BjsjDJZ',
                currentStep: 1,
                steps: 2,
                nextButton: false,
            }
        },
        computed: {
            barWidth() {
                return ((this.currentStep / this.steps) * 100) + '%'
            },
        },
        mounted() {
            this.getTxCarriers()
        },
        methods: {
            getTxCarriers() {
                let formData = new FormData
                formData.append('action', 'verify_tx_carriers')
                axios.post(ajaxObject.url, formData).then(({data}) => {
                    let response = JSON.parse(data.data)
                    if (typeof response.payers === 'undefined') {
                        return
                    }
                    this.carriers = response.payers
                })
            },
            submit() {
                let captchaResponse = document.getElementById(
                    'verify-captcha').dataset.response
                if (captchaResponse.length <= 0) {

                    Swal.fire({
                        title: 'Thank you!',
                        text: 'Unable to verify, please check the recaptcha checkbox',
                        type: 'info',
                    })
                }

                let formData = new FormData
                formData.append('action', 'verify_insurance')
                formData.append('name', 'verify-insurance')
                formData.append('first_name', this.first_name)
                formData.append('last_name', this.last_name)
                formData.append('member_id', this.member_id)
                formData.append('type', 'verify_tx')
                formData.append('payer_id', this.payer_id.payerId)
                formData.append('date_of_birth', this.date_of_birth)
                formData.append('subscriber_relation', this.subscriber_relation)
                formData.append('insurance_phone', this.insurance_phone)
                formData.append('client_email', this.client_email)
                formData.append('client_phone', this.client_phone)
                formData.append('ssn', this.ssn)
                formData.append('gender', this.gender)
                formData.append('g_recaptcha_response', captchaResponse)
                formData.append('website_url', window.location.href)

                axios.post(ajaxObject.url, formData).then(() => {
                    Swal.fire(
                        'Success!',
                        'We have received your information and a member of our admissions staff will be in touch with you shortly.',
                        'success',
                    ).then(() => {
                        window.location.reload()
                    })
                }).catch((error) => {
                    Swal.fire({
                        title: 'Thank you!',
                        text: 'We have received your information and a member of our admissions staff will be in touch with you shortly.',
                        type: 'info',
                    }).then(() => {
                        console.log(error)
                        if (typeof error.response.errors !== 'undefined') {
                            this.formError.record(error.response.errors)
                        }
                    })
                })
            },
            isStepOneDone() {
                if (this.client_email.length > 3 &&
                    this.client_phone.length > 3 &&
                    this.payer_id.length > 1) {
                    this.nextButton = true
                }
            },
            isStepTwoDone() {
                if (this.first_name.length > 3 &&
                    this.last_name.length > 3 &&
                    this.date_of_birth.length > 2 &&
                    this.gender.length >= 1 &&
                    this.member_id.length >= 1) {
                    this.nextButton = true
                }
            },
            nextStep() {
                this.nextButton = false
                this.currentStep++
            },
            previous() {
                if (this.currentStep <= 1) return
                this.currentStep--
            },
            next() {
                if (this.currentStep >= this.steps) return
                this.currentStep++
            },
        },
        components: {
            flatPickr: () => import('vue-flatpickr-component'),
        },
    })
})

let contactForms = document.querySelectorAll('.contact-form')
contactForms.forEach((contactForm) => {
    new Vue({
        el: '.contact-form-' + contactForm.dataset.id,
        props: {
            redirectUrl: {
                type: String,
                required: true,
                default: '/',
            },
            backgroundColor: {
                type: String,
                default: '',
            },
            hasLabels: {
                type: Boolean,
                default: false,
            },
            formType: {
                type: String,
                default: 'sidebar-contact-form',
            },
        },
        data: {
            formError: new FormError(),
            name: '',
            phone: '',
            email: '',
            message: '',
            key: '6LcgxrkUAAAAAKNQNCMShCnVGQcDcJDLCD-GBz6i',
        },
        methods: {
            submit() {
                let formData = new FormData
                let captchaResponse = document.getElementById(
                    'contact-captcha').dataset.response
                if (captchaResponse.length <= 0) {
                    Swal.fire({
                        title: 'Thank you!',
                        text: 'Unable to verify, please check the recaptcha checkbox',
                        type: 'info',
                    })
                }
                formData.append('action', 'form_submission')
                formData.append('client_name', this.name)
                formData.append('phone', this.phone)
                formData.append('email', this.email)
                formData.append('message', this.message)
                formData.append('type', this.formType)
                formData.append('website_url', window.location.href)
                formData.append('g_recaptcha_response', captchaResponse)

                axios.post(ajaxObject.url, formData).then(() => {
                    window.location.href = this.redirectUrl
                }).catch((error) => {
                    Swal.fire({
                        title: 'Thank you!',
                        text: 'We have received your information and a member of our admissions staff will be in touch with you shortly.',
                        type: 'info',
                    }).then(() => {
                        if (typeof error.response.errors !== 'undefined') {
                            this.formError.record(error.response.errors)
                        }
                    })
                })
            },
        },
    })
})

let sidebarForms = document.querySelectorAll('.sidebar-form')
sidebarForms.forEach((sidebarForm) => {
    new Vue({
        el: '.sidebar-form-' + sidebarForm.dataset.id,
        props: {
            redirectUrl: {
                type: String,
                required: true,
                default: '/',
            },
            backgroundColor: {
                type: String,
                default: '',
            },
            hasLabels: {
                type: Boolean,
                default: false,
            },
            formType: {
                type: String,
                default: 'sidebar-contact-form',
            },
        },
        data: {
            formError: new FormError(),
            name: '',
            phone: '',
            email: '',
            message: '',
            key: '6LcgxrkUAAAAAKNQNCMShCnVGQcDcJDLCD-GBz6i',
        },
        methods: {
            submit() {
                let formData = new FormData
                let captchaResponse = document.getElementById(
                    'sidebar-captcha').dataset.response
                if (captchaResponse.length <= 0) {
                    Swal.fire({
                        title: 'Thank you!',
                        text: 'Unable to verify, please check the recaptcha checkbox',
                        type: 'info',
                    })
                }
                formData.append('action', 'form_submission')
                formData.append('client_name', this.name)
                formData.append('phone', this.phone)
                formData.append('email', this.email)
                formData.append('message', this.message)
                formData.append('type', this.formType)
                formData.append('website_url', window.location.href)
                formData.append('g_recaptcha_response', captchaResponse)

                axios.post(ajaxObject.url, formData).then(() => {
                    window.location.href = this.redirectUrl
                }).catch((error) => {
                    Swal.fire({
                        title: 'Thank you!',
                        text: 'We have received your information and a member of our admissions staff will be in touch with you shortly.',
                        type: 'info',
                    }).then(() => {
                        if (typeof error.response.errors !== 'undefined') {
                            this.formError.record(error.response.errors)
                        }
                    })
                })
            },
        },
    })
})

let sobrietyCalculator = document.querySelectorAll('.sobriety-form')
if (sobrietyCalculator.length) {
    import('vue-social-sharing').then((module) => {
        Vue.use(module)
    })

    sobrietyCalculator.forEach((calculator) => {
        new Vue({
            el: '.sobriety-form-' + calculator.dataset.id,
            data: {
                date: null,
                step: 1,
                imageIndex: null,
                image: null,
                layout: null,
                images: [],
                assetsURL: null,
                hideNonSelectedImages: false,
                finalImage: null,
                captchaError: false,
                loading: false,
                defaultImage: null,
            },
            computed: {
                years() {
                    let years = new Date(new Date() - new Date(this.date)).getFullYear() - 1970
                    return years < 1 ? 0 : years
                },
                months() {
                    let dateTo = new Date()
                    let dateFrom = new Date(this.date)
                    let months = dateTo.getMonth() - dateFrom.getMonth()
                        + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))

                    if (dateTo.getDate() < dateFrom.getDate()) {
                        months--
                    }

                    return months < 1 ? 0 : months
                },
                weeks() {
                    let dateTo = new Date()
                    let dateFrom = new Date(this.date)
                    let differenceInTime = dateTo.getTime() - dateFrom.getTime()

                    return Math.floor(differenceInTime / (1000 * 3600 * 24 * 7))
                },
                days() {
                    let dateTo = new Date()
                    let dateFrom = new Date(this.date)
                    let differenceInTime = dateTo.getTime() - dateFrom.getTime()

                    return Math.floor(differenceInTime / (1000 * 3600 * 24))
                },
                currentUrl() {
                    return window.location.href
                }
            },
            mounted() {
                if (this.defaultImage) {
                    this.finalImage = this.defaultImage
                }
            },
            methods: {
                nextStep() {
                    if (this.date === null) return

                    let captchaElement = document.getElementById('sobriety-captcha')
                    let captchaResponse = captchaElement.dataset.response
                    if (captchaResponse === '') {
                        this.captchaError = true
                        return
                    }

                    this.captchaError = false
                    this.step = 2
                    this.layout = 'facebook'
                    this.getImages()
                },
                selectImage(selected) {
                    this.imageIndex = selected
                    this.image = this.images[selected]
                    this.hideNonSelectedImages = true
                },
                getImages() {
                    this.hideNonSelectedImages = false
                    this.loading = true
                    let formData = new FormData
                    formData.append('action', 'sobriety_getter')
                    formData.append('layout', this.layout)
                    axios.post(ajaxObject.url, formData).then(({data}) => {
                        this.images = data.data.images
                        this.assetsURL = data.data.assets_url
                        this.loading = false
                    })
                },
                generateTemplate() {
                    this.loading = true

                    let captchaElement = document.getElementById('sobriety-captcha')
                    let captchaResponse = captchaElement.dataset.response
                    let formData = new FormData
                    formData.append('action', 'sobriety_generator')
                    formData.append('image', this.imageIndex)
                    formData.append('layout', this.layout)
                    formData.append('years', this.years)
                    formData.append('months', this.months)
                    formData.append('weeks', this.weeks)
                    formData.append('days', this.days)
                    formData.append('g_recaptcha_response', captchaResponse)

                    axios.post(ajaxObject.url, formData).then(({data}) => {
                        window.location.href = data.data.url
                    })
                },
                refresh() {
                    window.location.reload()
                },
                shareFacebook() {
                    FB.ui({
                        method: 'feed',
                        caption: 'Sobriety Calculator',
                        name: 'Sobriety Calculator',
                        description: 'Sobriety Description',
                        redirect_uri: window.location.href,
                        picture: this.finalImage
                    }, (response) => {
                        console.log('fb response: ')
                        console.log(response)
                    })
                }
            },
            components: {
                Loading: () => import('vue-loading-overlay'),
                DatePick: () => import('vue-date-pick')
            }
        })
    })
}

let numberCounters = document.querySelectorAll('.number-counter-wrapper')
numberCounters.forEach((numberCounter) => {
    new Vue({
        el: '.number-counter-' + numberCounter.dataset.id,
        components: {
            'number-counter': () => import('./components/utilities/NumberCounter.vue'),
        },
    })
})

let tabbedContents = document.querySelectorAll('.tabbed-content')
tabbedContents.forEach((tabbedContent) => {
    new Vue({
        el: '.tabbed-content-' + tabbedContent.dataset.id,
        components: {
            'tabbed-content': () => import('./components/TabbedContent.vue'),
        },
    })
})

let circledTabbedContents = document.querySelectorAll('.circle-tabbed-content')
circledTabbedContents.forEach((tabbedContent) => {
    new Vue({
        el: '.circle-tabbed-content-' + tabbedContent.dataset.id,
        components: {
            'circle-tabbed-content': () => import('./components/CircledTabbedContent.vue'),
        },
    })
})

let recentPrograms = document.querySelectorAll('.recent-programs')
recentPrograms.forEach((recentPrograms) => {
    new Vue({
        el: '.recent-programs-' + recentPrograms.dataset.id,
        components: {
            'recent-programs': () => import('./components/programs/RecentPrograms.vue'),
        },
    })
})

let accordions = document.querySelectorAll('.accordion-wrapper')
accordions.forEach((accordion) => {
    new Vue({
        el: '.accordion-wrapper-' + accordion.dataset.id,
        components: {
            'accordion-wrapper': () => import('./components/accordion/AccordionWrapper.vue'),
        },
    })
})

let categoryAccordions = document.querySelectorAll('.category-accordion')
categoryAccordions.forEach((accordion) => {
    new Vue({
        el: '.category-accordion-' + accordion.dataset.id,
        components: {
            'category-accordion': () => import('./components/accordion/CategoryAccordion.vue'),
        },
    })
})

let tabbedText = document.querySelectorAll('.tabbed-text')
tabbedText.forEach((tabbedText) => {
    new Vue({
        el: '.tabbed-text-' + tabbedText.dataset.id,
        components: {
            'tabbed-text': () => import('./components/admin/ModalField.vue'),
        },
    })
})

let stickyMenus = document.querySelectorAll('.sticky-menu')
stickyMenus.forEach((menu) => {
    new Vue({
        el: '.sticky-menu-' + menu.dataset.id,
        store,
        components: {
            'sticky-menu': () => import('./components/nav/StickyMenu.vue'),
        },
    })
})

let staffModals = document.querySelectorAll('.staff-modal')
staffModals.forEach((modal) => {
    new Vue({
        el: '.staff-modal-' + modal.dataset.id,
        components: {
            'staff-modals': () => import('./components/StaffModal.vue'),
        },
    })
})

let modalTrigger = document.querySelectorAll('.modal-trigger')
modalTrigger.forEach((modal) => {
    new Vue({
        el: '.modal-trigger-' + modal.dataset.id,
        store,
        components: {
            'modal-trigger': () => import('./components/utilities/ModalTrigger.vue'),
        },
    })
})

let globalModals = document.querySelectorAll('.global-modal')
globalModals.forEach((modal) => {
    new Vue({
        el: '.global-modal-' + modal.dataset.id,
        store,
        components: {
            'global-modal': () => import('./components/utilities/GlobalModal.vue'),
        },
    })
})

let lightBoxes = document.querySelectorAll('.lightbox')
lightBoxes.forEach((lightbox) => {
    new Vue({
        el: '.lightbox-' + lightbox.dataset.id,
        store,
        components: {
            'lightbox-images': () => import('./components/utilities/Lightbox.vue'),
        },
    })
})

let drugs = document.querySelectorAll('.drugs')
drugs.forEach((drug) => {
    new Vue({
        el: '.drugs-' + drug.dataset.id,
        components: {
            'drugs': () => import('./components/Drugs.vue'),
        },
    })
})

let resourceCategories = document.querySelectorAll('.resource-categories')
resourceCategories.forEach((category) => {
    new Vue({
        el: '.resource-categories-' + category.dataset.id,
        components: {
            'resource-categories': () => import('./components/resources/ResourceCategories.vue'),
        },
    })
})
if (document.getElementById('post-categories')) {
    new Vue({
        el: '#post-categories',
        data: {
            categoryWidth: 0,
            categoryLeftPosition: 60,
            isWidthSet: false,
            totalPages: 0,
        },
        props: {
            preSelectedCategory: {
                type: String,
                default: null,
            },
        },
        mounted() {
            if (this.preSelectedCategory) {
                this.selectedCategory.slug = this.preSelectedCategory
            }

            this.setCategoriesWidth()
            setTimeout(() => {
                if (this.preSelectedCategory) {
                    let el = document.getElementById('blog-list')
                    let categoryLinkEl = document.getElementById(`category-link-${this.preSelectedCategory}`)
                    this.categoryLeftPosition = (-1 * categoryLinkEl.offsetLeft) + 60
                    Velocity(el, {
                        left: this.categoryLeftPosition + 'px',
                    })
                }
            }, 300)
        },
        methods: {
            previous() {
                if (this.categoryLeftPosition >= 60) {
                    this.categoryLeftPosition = 60
                } else {
                    this.categoryLeftPosition = this.categoryLeftPosition + 500
                }

                let el = document.getElementById('blog-list')
                Velocity(el, {
                    left: this.categoryLeftPosition + 'px',
                })
            },
            next() {
                let el = document.getElementById('blog-list')
                if ((Math.abs(this.categoryLeftPosition) + 1000) >= this.categoryWidth) return

                this.categoryLeftPosition = this.categoryLeftPosition - 500
                Velocity(el, {
                    left: this.categoryLeftPosition + 'px',
                })
            },
            setCategoriesWidth() {
                if (this.isWidthSet) return

                let categories = document.querySelectorAll('.category-link')
                categories.forEach((category) => {
                    this.categoryWidth += category.offsetWidth
                })
                this.categoryWidth = this.categoryWidth + 50
                this.isWidthSet = true
            },
        }
    })
}

if (document.getElementById('main-menu')) {
    new Vue({
        el: '#main-menu',
        store,
        data: {
            counter: 0,
            isChatActive: false,
            isSideBarActive: false,
            isVideoModalActive: false,
            overlayTopPosition: 0,
            overlayRightPosition: -100,
            desktopMenuPosition: 0,
            additionalAdminMenuHeight: 0,
        },
        computed: {
            ...mapGetters({
                phone: 'phone',
                isMobile: 'isMobile',
                topPosition: 'topPosition',
                isMenuSticky: 'isMenuSticky',
                isMenuActive: 'isMenuActive',
                isMobileMenuActive: 'isMobileMenuActive',
                isSecondMenuSticky: 'isSecondMenuSticky',
                isGetHelpMenuActive: 'isGetHelpMenuActive',
            }),
        },
        beforeMount() {
            this.resize()
            window.addEventListener('resize', this.resize)
            window.addEventListener('scroll', this.scroll)
        },
        mounted() {
            this.desktopMenuPosition = document.getElementById('nav-container').offsetTop
            this.isChatActive = true
        },
        methods: {
            resize() {
                if (window.innerWidth <= 991) {
                    this.setIsMobile()
                } else {
                    this.setIsDesktop()
                }
            },
            scroll() {
                let menuLink = document.getElementById('menu-contact-link')
                let menuContactButton = document.getElementById('menu-contact-btn')
                if (this.isMobile) {
                    if (menuLink) {
                        menuLink.style.display = 'block'
                    }

                    if (menuContactButton) {
                        menuContactButton.style.display = 'none'
                    }

                    return
                }

                if (window.pageYOffset >= this.desktopMenuPosition && !this.isMenuSticky && !this.isSecondMenuSticky) {
                    if (menuLink) {
                        menuLink.style.display = 'none'
                    }

                    if (menuContactButton) {
                        menuContactButton.style.display = 'block'
                    }

                    this.stickMenu()
                    return
                }

                if (window.pageYOffset < this.desktopMenuPosition && this.isMenuSticky) {
                    document.getElementById('menu-contact-link').style.display = 'block'
                    document.getElementById('menu-contact-btn').style.display = 'none'
                    this.unStickMenu()
                }
            },
            openMenu(el, done) {
                if (!el || el === 'undefined') return
                Velocity(el, {right: 0}, {duration: 500, complete: done})
            },
            closeMenu(el, done) {
                if (!el || el === 'undefined') return
                Velocity(el, {right: '-100%'}, {duration: 500}).then(() => {
                    this.purgeAllItems()
                })
            },
            toggleMenu() {
                let mainMenu = document.getElementById('main-menu')
                let overlay = mainMenu.querySelector('.overlay')

                this.overlayTopPosition = document.getElementById('nav-container').offsetTop +
                    document.getElementById('nav-container').offsetHeight

                this.toggleMenuService()

                if (overlay.style.display === 'block') {
                    overlay.style.display = 'none'
                    this.overlayRightPosition = '-100%'
                    let children = mainMenu.querySelectorAll('.sub-menu')
                    children.forEach((child) => {
                        let el = document.getElementById('sub-menu-' + child.dataset.id)
                        el.style.display = 'none'
                    })
                    return
                }

                overlay.style.display = 'block'
                this.overlayRightPosition = 0
            },
            itemColumns(size) {
                size = parseInt(size)
                if (typeof size === 'undefined' || size <= 0 || size > 12 || size === '') {
                    return 'col-12'
                }

                if (size === 5 ||
                    size === 6 ||
                    size === 7 ||
                    size === 8 ||
                    size === 9 ||
                    size === 10) {
                    return 'col'
                }

                return 'col-' + size
            },
            ...mapActions({
                stickMenu: 'stickMenu',
                toggleItem: 'toggleItem',
                unStickMenu: 'unStickMenu',
                setIsMobile: 'setIsMobile',
                setIsDesktop: 'setIsDesktop',
                purgeAllItems: 'purgeAllItems',
                addActiveItem: 'addActiveItem',
                toggleMenuService: 'toggleMenu',
                toggleIsMobile: 'toggleIsMobile',
                removeActiveItem: 'removeActiveItem',
                toggleGetHelpMenu: 'toggleGetHelpMenu',
                setTopPositionService: 'setTopPosition',
            }),
        },
        components: {
            'burger': () => import('./components/nav/Burger.vue'),
            'chat-bot': () => import('./components/Chatbot.vue'),
            'menu-item': () => import('./components/nav/MenuItem.vue'),
            'information-button': () => import('./components/InformationButton.vue'),
            'mobile-information-button': () => import('./components/MobileInformationButton.vue'),
        }
    })
}

// let socialMedia = document.querySelectorAll('.social-media')
// if (socialMedia.length) {
//     const SocialSharing = require('vue-social-sharing')
//     Vue.use(SocialSharing)
//     socialMedia.forEach((social) => {
//         new Vue({
//             el: '.social-media-' + social.dataset.id,
//         })
//     })
// }

let containers = Array.from(document.getElementsByClassName('container'))
let edgedSpace = containers[0].offsetLeft

Array.from(document.getElementsByClassName('cta')).forEach(
    (element, index, array) => {
        element.style.left = ((edgedSpace * -1) - 40) + 'px'
        element.style.paddingLeft = (edgedSpace + 40) + 'px'
    },
)

let homeFeatures = document.querySelectorAll('.feature')
if (homeFeatures) {
    homeFeatures.forEach((feature) => {
        if (feature.classList.contains('no-hover')) {
            return
        }

        feature.querySelectorAll('p a').forEach((aTag) => {
            feature.addEventListener('click', event => {
                window.location.href = aTag.href
            })
        })
    })
}

let tabbedTestimonials = document.querySelectorAll('.tabbed-testimonial')
if (tabbedTestimonials) {
    tabbedTestimonials.forEach((tab) => {
        new Vue({
            el: '.tabbed-testimonial-' + tab.dataset.id,
            components: {
                'tabbed-testimonials': () => import('./components/testimonials/TabbedTestimonials.vue'),
            },
        })
    })
}

let cityChooser = document.querySelectorAll('.location-chooser')
if (cityChooser) {
    cityChooser.forEach((chooser) => {
        new Vue({
            el: '.location-chooser-' + chooser.dataset.id,
            data: {
                options: [],
                selectedLocation: null
            },
            mounted() {
                let formData = new FormData
                formData.append('action', 'light_posts_getter')
                formData.append('per_page', -1)
                formData.append('post_type', 'page')
                formData.append('template', 'page-location.php')

                if (typeof chooser.dataset.excluded !== 'undefined' && chooser.dataset.excluded) {
                    formData.append('excluded', chooser.dataset.excluded)
                }

                axios.post(ajaxObject.url, formData).then(({data}) => {
                    console.log(data.data)
                    this.options = data.data.posts
                }).catch((response) => {
                    console.log(response)
                })
            },
            methods: {
                chooseCity() {
                    if (typeof this.selectedLocation.guid !== 'undefined' && this.selectedLocation) {
                        window.location = this.selectedLocation.guid
                    }
                }
            }
        })
    })
}

var last = null, x0, x1, x2, x3, y0, y1, y2, y3, link, timeout
let mainMenu = document.getElementById('main-menu')
if (mainMenu.dataset.ismobile !== 'true') {
    mainMenu.addEventListener('mouseleave', function (event) {
        event.preventDefault()
        mainMenu.dataset.hovering = 'off'
        clearTimeout(timeout)
        let items = mainMenu.querySelectorAll('.hover-item[data-hovering=\'true\']')
        items.forEach(item => {
            item.dataset.hovering = 'false'
            closeSubMenu(item)
        })
    })

    let menuItems = document.querySelectorAll('.hover-item')
    let timer

    menuItems.forEach((item) => {
        if (typeof item.dataset.id === 'undefined' || item.dataset.id === '') return

        item.addEventListener('mouseover', function () {
            if (item.dataset.hovering === 'true') return
            item.dataset.hovering = 'true'

            timer = setTimeout(function () {
                openSubMenu(item)
            }, 300)
        })

        item.addEventListener('mouseleave', function () {
            if (item.dataset.hovering === 'false') return

            item.dataset.hovering = 'false'
            closeSubMenu(item)
            clearTimeout(timer)
        })
    })
} else {
    let toggleIcons = document.querySelectorAll('.dropdown-toggle-icon')
    toggleIcons.forEach((icon) => {
        icon.onclick = function (event) {
            event.preventDefault()
            icon.classList.toggle('dropdown-active')
            let el = document.getElementById('sub-menu-' + icon.dataset.id)
            toggle(el)
        }
    })
}

function openSubMenu(parent) {
    let id = parent.dataset.id
    let el = document.getElementById('sub-menu-' + id)
    if (typeof el === 'undefined' || !el) return

    let effect = 'fadeIn'
    let options = {
        display: 'block',
        duration: 200,
    }
    if (parent.dataset.flyout === 'left') {
        el.style.left = '-100%'
    }

    if (mainMenu.dataset.ismobile === 'true') {
        options.duration = 200
        effect = 'slideDown'
    }
    if (el.dataset.full === 'true') {
        el.style.width = itemWidth(el)
        el.style.left = itemLeft(el)
    }
    Velocity(el, effect, options)
}

function closeSubMenu(parent) {
    let id = parent.dataset.id
    let el = document.getElementById('sub-menu-' + id)
    if (typeof el === 'undefined' || !el) return

    let effect = 'fadeOut'
    let options = {
        display: 'none',
        duration: 100,
    }

    if (mainMenu.dataset.ismobile === 'true') {
        options.duration = 300
        effect = 'slideUp'
    }

    Velocity(el, effect, options).then(() => {
        parent.dataset.hovering = 'false'
    })
}

function toggle(el) {
    if (el.style.display === 'block') {
        closeSubMenu(el)
        let children = el.querySelectorAll('.sub-menu')
        children.forEach((child) => {
            let el = document.getElementById('sub-menu-' + child.dataset.id)
            el.style.display = 'none'
        })
        return
    }
    openSubMenu(el)
}

function itemWidth(item) {
    let width = document.getElementById('nav-container').offsetWidth
    if (item.dataset.from === '_blank') {
        return width - item.parentElement.parentElement.offsetLeft + 'px'
    }

    return width + 'px'
}

function itemLeft(item) {
    if (item.dataset.from === '_blank') {
        return 0
    }

    return (-item.parentElement.parentElement.offsetLeft) + 'px'
}

setTimeout(() => {
    let scrollTos = document.querySelectorAll('.scroll-to')
    scrollTos.forEach((scroll) => {
        scroll.addEventListener('click', (event) => {
            let elName = scroll.getAttribute('href')
            elName = elName.replace('#', '')
            let element = document.getElementById(elName)
            Velocity(element, 'scroll', {duration: 1000, easing: 'easeInSine', offset: -80})
        })
    })
}, 2000)

let screenWidth = window.innerWidth
if (screenWidth > 991) {
    let sidebarEl = document.getElementById("sticky-sidebar")
    let mainBody = document.querySelector(".main-body")
    if (sidebarEl && mainBody) {
        let bodyCoords = mainBody.getBoundingClientRect()
        let originalSidebarCoords = sidebarEl.getBoundingClientRect()
        if (originalSidebarCoords.height + 130 < bodyCoords.height) {
            let StickSidebar = require('sticky-sidebar')
            new StickySidebar('#sticky-sidebar', {
                topSpacing: 130,
                bottomSpacing: 0,
                containerSelector: 'body > .container',
                innerWrapperSelector: '.inner-sidebar',
            })
        }
    }
}
